import { Page, Route } from "./models"

export const routes: Record<Page, Route> = {
    Dashboard: {
        pageTitle: "Dashboard",
        href: "/dashboard",
        defaultRouteOrder: 1,
    },
    Subscriptions: {
        pageTitle: "Subscriptions",
        href: "/subscriptions",
        defaultRouteOrder: 2,
    },
    Invoices: {
        pageTitle: "Invoices",
        href: "/invoices",
        defaultRouteOrder: 3,
    },
    PaymentMethods: {
        pageTitle: "Payment Methods",
        href: "/payment-methods",
        defaultRouteOrder: 4,
    }
}
